import { render, staticRenderFns } from "./UploadMaterialDialog.vue?vue&type=template&id=ddaf65aa&scoped=true&"
import script from "./UploadMaterialDialog.vue?vue&type=script&lang=js&"
export * from "./UploadMaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadMaterialDialog.vue?vue&type=style&index=0&id=ddaf65aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaf65aa",
  null
  
)

export default component.exports